import React from "react";

// Components
import { AddContact } from "shared/components/user";
import Overlay from "shared/components/overlay/Overlay";
import SlidingPanel from "shared/components/sliding-panel/SlidingPanel";

// Styles
import styles from './AddContact.module.scss';


const AddContactPanel = ({ isActive=false, onAddNewContact, onClose }) => {
    return (
        <div className={ styles.wrapper }>
            <SlidingPanel className={ styles.panel } isActive={ isActive }>
                { <AddContact
                    onClose={ onClose }
                    onAddNewContact={ onAddNewContact } />
                }
            </SlidingPanel>

            <Overlay isActive={ isActive } isContained onClick={ onClose } />
        </div>
    )
}

export default AddContactPanel;
